import gql from 'graphql-tag';

export const ACCOUNT_QUERY = gql`
query getAccount($accountId: ID!) {
    activeLocales
    account(id: $accountId) {
      id
      displayName
      isHeadOfFamily
      localAriFields {
        id
        dataType
        question
        answers
        mandatory
      }   
      globalAriFields {
        id
        dataType
        question
        answers
        mandatory
        enabled
        accountsWithFieldEnabled {
          id
          displayName
        }
        availableAccountsToEnable {
          id
          displayName
        }
      }
      subAccountsLocalFieldUseEnabled
      canUseLocalAriFields
      canCreateGlobalAriFields    
    }
  }  
`;

export const USER_AGREEMENT = gql`
 query getUserAgreement($first: Int) {
  viewer {
    id
    accounts(first: $first) {
      edges {
        agreedToGdprTerms
        node {
          id
          displayName
        }
      }
    }
  }
}
 `;
